"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAllowedTypes = extractAllowedTypes;
exports.extractAllowedSchemas = extractAllowedSchemas;
const schema_1 = require("../schema");
function isSchemaAllowed(schema, application) {
    return schema.applications.includes(application) && !schema.disabled;
}
function extractAllowedTypes(application) {
    const allowedTypes = [];
    Object.keys(schema_1.SearchSchema).forEach((key) => {
        if (isSchemaAllowed(schema_1.SearchSchema[key], application)) {
            allowedTypes.push(key);
        }
    });
    return allowedTypes;
}
function extractAllowedSchemas(application) {
    const allowedTypes = [];
    Object.values(schema_1.SearchSchema).forEach((schema) => {
        if (isSchemaAllowed(schema, application)) {
            allowedTypes.push(schema);
        }
    });
    return allowedTypes;
}
//# sourceMappingURL=extract-appropriate-types.js.map